import { faCircleLeft } from "@fortawesome/free-solid-svg-icons/faCircleLeft";
import { faCircleRight } from "@fortawesome/free-solid-svg-icons/faCircleRight";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  ListarTipoEntrega,
  ModalidadesEntrega,
  PontosRetirada,
  SimularDescontoItem
} from "app/api/classes/OrcamentoApi";
import microuniversoApi from "app/api/microuniversoApi";
import { useAppSelector } from "app/redux/hooks";
import { IFilial } from "app/types/IFilial";
import { IItemOrcamento } from "app/types/IItemOrcamento";
import { Parametro, ParametroPorItem } from "app/types/Parametro";
import { WindowMU } from "app/types/WindowMU";
import {
  alterarPrecoItem as alterarPrecoItemUseCase,
  alterarQuantidadeItem as alterarQuantidadeItemUseCase,
  alterarPercentualMarkupItem as alterarPercentualMarkupItemUseCase, // 449290
  tratamentoErroPadrao
} from "app/use-cases";
import { obterPermissao } from "app/use-cases/obterPermissao";
import { alterarDataMarcadaEntregaItem } from "app/use-cases/orcamento/alterarDataMarcadaEntregaItem";
import { alterarDataPrevisaoEntregaItem } from "app/use-cases/orcamento/alterarDataPrevisaoEntregaItem";
import { alterarOrdemPedidoCompraItem } from "app/use-cases/orcamento/alterarOrdemPedidoCompraItem";
import { alterarTipoEntregaItem } from "app/use-cases/orcamento/alterarTipoEntregaItem";
import { alterarTurnoEntregaItem } from "app/use-cases/orcamento/alterarTurnoEntregaItem";
import { definirAliquotaItem } from "app/use-cases/orcamento/definirAliquotaItem";
import { definirDescricaoProdutoItem } from "app/use-cases/orcamento/definirDescricaoProdutoItem";
import { definirDespesasInclusasParaItemOrcamento } from "app/use-cases/orcamento/definirDespesasInclusasParaItensOrcamento";
import { definirEntregaPosteriorItem } from "app/use-cases/orcamento/definirEntregaPosteriorItem";
import { definirIdPontoRetiradaItem } from "app/use-cases/orcamento/definirIdPontoRetiradaItem";
import { definirOidModalidadeEntregaItem } from "app/use-cases/orcamento/definirOidModalidadeEntregaItem";
import { definirPedidoDeCompraItem } from "app/use-cases/orcamento/definirPedidoDeCompraItem";
import { definirRegimeEspecialItem } from "app/use-cases/orcamento/definirRegimeEspecialItem";
import { definirValorIPIItem } from "app/use-cases/orcamento/definirValorIPIItem";
import { definirVendaSobEncomendaItem } from "app/use-cases/orcamento/definirVendaSobEncomendaItem";
import { definirOfertaSeletivaItem } from "app/use-cases/orcamento/itens/definirOfertaSeletivaItem";
import { substituirDataMarcadaDataPrevisaoEntregaItens } from "app/use-cases/orcamento/substituirDataMarcadaDataPrevisaoEntregaItens";
import { obterParametros, obterParametrosPorOidItem } from "app/use-cases/parametro/obterParametros";
import clsx from "clsx";
import globalMU from "globalMU";
import React, { useEffect, useState } from "react";
import { Breadcrumb2Container } from "../breadcrumb2/Breadcrumb2Container";
import { ItensOrcamentoContainer } from "../itens-orcamento/ItensOrcamentoContainer";
//import { ProdutoSemEstoqueDisponivelContainer } from "./produto-sem-estoque-disponivel/ProdutoSemEstoqueDisponivelContainer"
import { removerComponenteReact, renderizarComponentReact } from "../renderizarOuRemoverComponentReact";
import {
  EditarItem,
  ListaTiposFaturamento,
  ListaTurnoEntrega
} from "./EditarItem";
/*
import {
  
  DadosSimularDesconto,
  ModalSimularDesconto
} from "./modal-simular-descontos/modalSimularDesconto";
*/
import { definirPreservaDesconto } from "app/use-cases/orcamento/definirPreservaDesconto";
import { EditarPrecoTintaContainer } from "./editar-preco-tinta/EditarPrecoTintaContainer";
import { ItemOrcamentoController } from "app/controllers/orcamento/itemOrcamentoController";
import { ControllerLegado } from "app/types/ControllerLegado";
import { ModalSimularDescontoContainer } from "./modal-simular-descontos/ModalSimularDescontoContainer";
import { DefinirMotivoDescontoItem } from "app/use-cases/orcamento/DefinirCodigoMotivoDescontoItem";
import { CodigoTipoEntrega } from "app/types/CodigoTipoEntrega";
import { DataFormatoEN } from "app/types/DataFormatoEN";
import { CodigoTurnoEntrega } from "app/types/CodigoTurnoEntrega";
import { definirFilialRetiradaItem } from "app/use-cases/orcamento/definirFilialRetiradaItem";
import { definirFilialTransferenciaItem } from "app/use-cases/orcamento/definirFilialTransferenciaItem";
import { definirTipoFaturamentoItem } from "app/use-cases/orcamento/definirTipoFaturamentoItem";
import useEffectWithPrevious from "app/hooks/useEffectWithPrevious";
import { ModalVendaSobEncomendaContainer } from "./modal-venda-sob-encomenda/ModalVendaSobEncomendaContainer";
import { ehNecessarioMostrarModalVendaSobEncomenda } from "app/use-cases/orcamento/ehNecessarioMostrarModalVendaSobEncomenda";
const estilosBotoes = require("../../estilos/botoes.module.scss").default;
import { v4 as uuidv4 } from 'uuid';
import store from "app/redux/store/store";
import { definirEncomendaExpressaItem } from "app/use-cases/orcamento/definirEncomendaExpressaItem";
import { definirPrioridadeMontagemItem } from "app/use-cases/orcamento/definirPrioridadeMontagemItem"; // 456839
import { alterarMostruarioItem } from "app/use-cases/orcamento/alterarMostruarioItem"; // PA 487087
import { ModalServicosAgregadosContainer } from "../servicos-agregados/ModalServicosAgregadosContainer";
import { RemoverServicosAgregados } from "app/use-cases/orcamento/RemoverServicosAgregados";
import { set } from "date-fns";

declare var window: WindowMU;


export type EditarItemContainerProps = {
  identificadorItem: number
  itemOrcamentoController: ControllerLegado
  exibirBotoesProximoEAnterior: boolean
  botaoAnteriorDesativado: boolean
  onExibirTelaProdutoSemEstoqueDisponivel: () => void
  onBotaoAnteriorClicado: () => void
  onBotaoProximoClicado: () => void
};

export const EditarItemContainer = (props: EditarItemContainerProps) => {
  const orcamento = useAppSelector((store) => store.orcamento)
  const [chaveComponente, setChaveComponente] = useState(uuidv4())
  const [exibirLocalRetirada, setExibirLocalRetirada] = useState(false);
  const [parametros, setParametros] = useState<Parametro[]>([])
  const [parametrosPorFilial, setParametrosPorFilial] = useState<ParametroPorItem[]>([]) // 433263
  const [tipoEntrega, setTipoEntrega] = useState<ListarTipoEntrega[]>([]);
  const [filiais, setfiliais] = useState<IFilial[]>([]);
  const [filiaisRetirada, setfiliaisRetirada] = useState<IFilial[]>([]) // 472865
  const [faturamento, setFaturamento] = useState<ListaTiposFaturamento[]>([]);
  const [turnoEntrega, setTurnoEntrega] = useState<ListaTurnoEntrega[]>([]);
  const [openModalVenda, setOpenModalVenda] = useState(false);
  const [desativarEdicaoOrdemPedidoCompra, setDesativarEdicaoOrdemPedidoCompra] = useState(false);
  const [listaModalidadesEntrega, setListaModalidadesEntrega] = useState<ModalidadesEntrega[]>([]);
  const [listaPontosRetirada, setListaPontosRetirada] = useState<PontosRetirada[]>([]);
  const [utilizaModalidadeEntregaOrcamento, setUtilizaModalidadeEntregaOrcamento] = useState(false);

  const [parametrosCarregados, setParametrosCarregados] = useState(false)
  const [itemSelecionadoParaSimularDesconto, setItemSelecionadoParaSimularDesconto] = useState<IItemOrcamento>(null)
  const [motivosDesconto, setMotivosDesconto] = useState<{
    Codigo?: number
    Motivo?: string
  }[]>([])
  const [item, setItem] = useState<IItemOrcamento>((orcamento.ItensOrcamento ?? []).find(i => i.Identificador == props.identificadorItem))
  const [mostrarModalVendaSobEncomenda, setMostrarModalVendaSobEncomenda] = useState(false)
  const [mostrarModalVendaSobEncomendaManual, setMostrarModalVendaSobEncomendaManual] = useState(false)
  const [mostrarModalServicoAgregados, setMostrarModalServicoAgregados] = useState(false)
  const [dataMaximaParaPrevisaoEntrega, setDataMaximaParaPrevisaoEntrega] = useState<{ year: number, month: number, day: number }>(null)

  useEffectWithPrevious(([itemAnterior]) => {

    if (ehNecessarioMostrarModalVendaSobEncomenda({
      dadosItemAtual: {
        CodigoFilialRetirada: item.CodigoFilialRetirada,
        CodigoTipoEntrega: item.CodigoTipoEntrega,
        Quantidade: item.Quantidade,
        VendaSobEncomenda: item.VendaSobEncomenda
      },
      dadosItemAnterior: {
        CodigoFilialRetirada: itemAnterior.CodigoFilialRetirada,
        CodigoTipoEntrega: itemAnterior.CodigoTipoEntrega,
        Quantidade: itemAnterior.Quantidade,
        VendaSobEncomenda: itemAnterior.VendaSobEncomenda
      }

    })) {
      setMostrarModalVendaSobEncomenda(true)
      setMostrarModalVendaSobEncomendaManual(false)
    }

  }, [item])

  const atualizarEditarItem = () => {
    setChaveComponente(uuidv4())
  }




  const numeroCasasDecimaisPreco = () => globalMU.isNullOrEmpty(valorParametro("CASAS_DECIMAIS_PRECO_VENDA")) || isNaN(Number(valorParametro("CASAS_DECIMAIS_PRECO_VENDA"))) ? 2 : Number(valorParametro("CASAS_DECIMAIS_PRECO_VENDA"))

  const atualizarParametros = async () => {
    setParametros(
      await obterParametros({
        nomes: [
          "APURA_IPI_VENDA",
          "PERMITE_VENDA_RETIRADA_LOCAL_TRANSFERENCIA", //472865
          //"APURA_IPI_VENDA_FILIAL",
          //"PERMITE_DESATIVAR_REGIME_ESPECIAL_ITEM_PEDIDO",
          //"UTILIZA_EMISSAO_AUTOMATICA_NF_VENDA_APOS_TRANSFERENCIA_CD",
          "DEFINIR_PREVISAO_ENTREGA_POR_ITEM",
          "OFERTA_SELETIVA",
          "BLOQUEAR_EDICAO_VALOR_IPI_ORCAMENTO",
          "TRATAR_VENDAS_SOB_ENCOMENDA",
          //"EXIBIR_OUTRAS_DESPESAS_ITENS_ORCAMENTO",
          //"VENDA_COM_ENTREGA_POSTERIOR_POR_ITEM",
          "APURAR_ST_ORCAMENTO",
          //"PERMITE_INCLUIR_DESCRICAO_TEMP_PRODUTO_ORCAMENTO",
          "ACEITAR_PRODUTO_SEM_ESTOQUE",
          "BLOQUEIA_DESCONTO_UNITARIO_NO_ORCAMENTO",
          "TRATAMENTO_DIFERENCIADO_DATAS_MARCADAS_PREVISTAS_ORCAMENTO",
          //"ORCWEB_UTILIZA_DESCONTO_MAXIMO_BONIFICACAO_AVANCADOS",
          "CASAS_DECIMAIS_PRECO_VENDA",
          "DESCONTO_ACUMULADO",
          "PERMITIR_PRESERVAR_DESCONTO_ITEM_ORCAMENTO",
          "ORCAMENTO_MASCARA_QUANTIDADE",
          "VISUALIZA_MARKUP_PRODUTO_ORCAMENTO", // 449240
          "CUSTO_PARA_GERAR_MARKUP", // 449240
        ]
      })
    )

    setParametrosPorFilial( // 433263
      await obterParametrosPorOidItem({
        nomes: ["UTILIZA_RECURSO_ENCOMENDA_EXPRESSA",
          "OBRIGATORIO_INFORMAR_TURNO_ORCAMENTO", // 475897
          "FILIAL_TRANSFERENCIA_VENDA_FUTURA_RETIRADA_LOCAL", //472865
          "UTILIZA_EMISSAO_AUTOMATICA_NF_VENDA_APOS_TRANSFERENCIA_CD",
          "VENDA_COM_ENTREGA_POSTERIOR_POR_ITEM",
          "ORCWEB_UTILIZA_DESCONTO_MAXIMO_BONIFICACAO_AVANCADOS",
          "PERMITE_DESATIVAR_REGIME_ESPECIAL_ITEM_PEDIDO",
          "PERMITE_INCLUIR_DESCRICAO_TEMP_PRODUTO_ORCAMENTO",
          "BLOQUEAR_FATURAMENTO_DIRETO_CLIENTE_RETIRADA_OUTRO_LOCAL", // 469010
          "EXIBIR_OUTRAS_DESPESAS_ITENS_ORCAMENTO",
          "APURA_IPI_VENDA_FILIAL",
          "UTILIZA_SERVICO_AGREGADO_ORCAMENTO",
        ],
        oidItem: orcamento.OidFilialOrcamento
      })
    )

  };

  const permitidoAcaoFuncionalidade = async (
    siglaFuncionalidade: string,
    acao: string
  ) => await obterPermissao({ funcionalidade: siglaFuncionalidade, acao });

  const valorParametro = (nome: string) =>
    parametros.find((p) => p.Nome == nome)?.Valor;

  const valorParametroPorFilial = (nome: string) => parametrosPorFilial.find((p) => p.Nome == nome)?.Valor; // 433263
  /*
    const atualizarExibicaoLocalRetirada = async () => {
      setExibirLocalRetirada(
        await permitidoAcaoFuncionalidade(
          "ORCAMENTO_ITEM_VENDA",
          "MOSTRAR_LOCAL_RETIRADA"
        )
      );
    };
  */
  const atualizarExibicaoLocalRetirada = async () => {
    let mostrarLocalRetirada = (orcamento.TipoOrcamentoDescricao == "Venda"
      || (orcamento.TipoOrcamentoDescricao == "Outras Saídas" && parametros.find(p => p.Nome == "ORCAMENTO_OUTRAS_SAIDAS_RETIRADA_OUTRO_LOCAL")?.Valor == "S")
    )
    if (mostrarLocalRetirada) {
      mostrarLocalRetirada = await permitidoAcaoFuncionalidade(
        "ORCAMENTO_ITEM_VENDA",
        "MOSTRAR_LOCAL_RETIRADA"
      )
    }
    setExibirLocalRetirada(mostrarLocalRetirada)
  }

  const listarTipoEntrega = async () => {
    globalMU.blockUI();
    try {
      setTipoEntrega(await microuniversoApi.Orcamento.listarTipoEntrega());
      globalMU.unblockUI();
    } catch (erro) {
      tratamentoErroPadrao(erro);
      globalMU.unblockUI();
    }
  };

  const listarTiposFaturamento = () => {
    setFaturamento([
      { Description: "Transferência", Value: "0" },
      { Description: "Direto para o cliente", Value: "1" },
    ]);
  };
  const listarTurnoEntrega = () => {
    let turnos = 
    [
      { Description: "Manhã", Value: "0" },
      { Description: "Tarde", Value: "1" }
    ]
    if (valorParametro("DEFINIR_PREVISAO_ENTREGA_POR_ITEM") == "S" && valorParametroPorFilial("OBRIGATORIO_INFORMAR_TURNO_ORCAMENTO") == "S") 
    { 
      turnos.push({ Description: "Noite", Value: "2" }) // 475897
      turnos.push({ Description: "Indiferente", Value: "3" }) // 475897
    }
    setTurnoEntrega(turnos);
  };

  const listarFiliaisRetirada = async () => {
    globalMU.blockUI();
    try {
      /*
      setfiliais(await microuniversoApi.Orcamento.listarFiliaisRetirada());
      */
      const filiais = await microuniversoApi.Orcamento.listarFiliaisRetirada() // 472865 - pa 471187
      setfiliais(filiais)
      const permiteVENDA_RETIRADA_LOCAL_TRANSFERENCIA = valorParametro("PERMITE_VENDA_RETIRADA_LOCAL_TRANSFERENCIA")
      const permiteFILIAL_TRANSFERENCIA_VENDA_FUTURA_RETIRADA_LOCAL = valorParametro("FILIAL_TRANSFERENCIA_VENDA_FUTURA_RETIRADA_LOCAL") // 472865 - pa 471187

      if (permiteVENDA_RETIRADA_LOCAL_TRANSFERENCIA !== "S" && Number(permiteFILIAL_TRANSFERENCIA_VENDA_FUTURA_RETIRADA_LOCAL) > 7) // 472865
      {
        setfiliaisRetirada(filiais.filter(f => f.Codigo != orcamento.CodigoFilialOrcamento)) // 472865
      }
      else {
        setfiliaisRetirada(filiais)
      }
    } catch (erro) {
      tratamentoErroPadrao(erro);
      globalMU.unblockUI();
    }
  };

  const onQuantidadeAlterado = async (
    identificadorItem: number,
    quantidade: number
  ) => {
    globalMU.blockUI()

    const item = (orcamento.ItensOrcamento ?? []).find(
      (i) => i.Identificador == identificadorItem
    );
    try {
      await alterarQuantidadeItemUseCase({
        identificadorItem,
        quantidade,
        quantidadeEstoque: item?.QuantidadeEstoque,
        quantidadeSolicitada: item?.QuantidadeSolicitada,
      });
      // onDadosModalVendaSobEncomenda(identificadorItem);
      // valorParametro("TRATAR_VENDAS_SOB_ENCOMENDA") == "4" ||
      //   (dadosEncomendaProduto?.QuantidadeDisponivel <= 0
      //     ? true
      //     : quantidade <= item?.QuantidadeEstoque
      //       ? false
      //       : setOpenModalVenda(true));
      globalMU.unblockUI();
    } catch (erro) {
      tratamentoErroPadrao(erro);
      globalMU.unblockUI();
    }
  };

  const onPercentualMarkUpModificado = async ( // 449240
    identificadorItem: number,
    percentualMarkup: number) => {
    globalMU.blockUI()
    const item = (orcamento.ItensOrcamento ?? []).find((i) => i.Identificador == identificadorItem);
    try {
      await alterarPercentualMarkupItemUseCase({ identificadorItem, percentualMarkup })
    } catch (erro) {
      tratamentoErroPadrao(erro);
    }
    finally {
      globalMU.unblockUI();
    }
  };

  const onPrecoItemAlterado = async (
    identificadorItem: number,
    preco: number,
    percentualDesconto: number,
    percentualBonificacao: number
  ) => {
    globalMU.blockUI();
    try {
      await alterarPrecoItemUseCase({
        identificadorItem,
        preco,
        percentualDesconto,
        percentualBonificacao,
      });
      globalMU.unblockUI();
    } catch (erro) {
      tratamentoErroPadrao(erro);
      globalMU.unblockUI();
    }
  };



  const onFilialRetiradaAlterada = async (
    codigoFilialRetirada: string,
    identificadorItem: number
  ) => {
    globalMU.blockUI();
    try {
      await definirFilialRetiradaItem({
        identificadorItem,
        codigoFilialRetirada,
        atualizarEstadoLegadoImediatamente: true
      });
      globalMU.unblockUI();
    } catch (e) {

      tratamentoErroPadrao(e);
      globalMU.unblockUI();
    }
  };

  const onOidModalidadeEntregaAlterado = async (
    oidModalidadeEntregaItem: number,
    identificadorItem: number
  ) => {
    globalMU.blockUI();
    try {
      await definirOidModalidadeEntregaItem({
        identificadorItem,
        oidModalidadeEntregaItem,
        atualizarEstadoLegadoImediatamente: true
      });
      globalMU.unblockUI();
    } catch (e) {
      tratamentoErroPadrao(e);
      globalMU.unblockUI();
    }
  };

  const onIdPontoRetiradaAlterado = async (
    idPontoRetiradaItem: number,
    identificadorItem: number
  ) => {
    globalMU.blockUI();
    try {
      await definirIdPontoRetiradaItem({
        identificadorItem,
        idPontoRetiradaItem,
        atualizarEstadoLegadoImediatamente: true
      });
      globalMU.unblockUI();
    } catch (e) {
      tratamentoErroPadrao(e);
      globalMU.unblockUI();
    }
  };

  const onTipoFaturamentoAlterado = async (
    tipoFaturamento: string,
    identificadorItem: number
  ) => {
    globalMU.blockUI();
    try {
      await definirTipoFaturamentoItem({
        tipoFaturamento,
        identificadorItem,
      });
      globalMU.unblockUI();
    } catch (e) {
      tratamentoErroPadrao(e);
      globalMU.unblockUI();
    }
  };

  const onDescricaoAlterado = async (
    descricao: string,
    identificadorItem: number
  ) => {
    globalMU.blockUI();
    try {
      await definirDescricaoProdutoItem({
        identificadorItem,
        descricao,
      });
      globalMU.unblockUI();
    } catch (e) {
      tratamentoErroPadrao(e);
      globalMU.unblockUI();
    }
  };

  const onDataPrevistaAlterado = async (
    dataPrevisaoEntrega: DataFormatoEN,
    identificadorItem: number
  ) => {
    globalMU.blockUI();
    try {
      await alterarDataPrevisaoEntregaItem({
        identificadorItem,
        dataPrevisaoEntrega

      });
      globalMU.unblockUI();
    } catch (e) {
      tratamentoErroPadrao(e);
      globalMU.unblockUI();
    }
  };

  const onReplicarData = async (dataMarcadaEntrega: DataFormatoEN) => {
    globalMU.blockUI();
    try {
      await substituirDataMarcadaDataPrevisaoEntregaItens({
        dataMarcadaEntrega,
      });
      globalMU.unblockUI();
    } catch (e) {
      tratamentoErroPadrao(e);
      globalMU.unblockUI();
    }
  };

  const onDataMarcadaAlterado = async (
    dataMarcadaEntrega: string,
    identificadorItem: number
  ) => {
    globalMU.blockUI();
    try {
      await alterarDataMarcadaEntregaItem({
        identificadorItem,
        dataMarcadaEntrega: dataMarcadaEntrega ?? ""
      });
      globalMU.unblockUI();
    } catch (e) {
      tratamentoErroPadrao(e);
      globalMU.unblockUI();
    }
  };

  const onTurnoEntregaAlterado = async (
    identificadorItem: number,
    turnoEntrega: CodigoTurnoEntrega
  ) => {
    globalMU.blockUI();
    try {
      await alterarTurnoEntregaItem({
        identificadorItem,
        turnoEntrega,
      });
      globalMU.unblockUI();
    } catch (e) {
      tratamentoErroPadrao(e);
      globalMU.unblockUI();
    }
  };

  const onFilialTransferenciaAlterada = async (
    codigoFilialTransferencia: string,
    identificadorItem: number
  ) => {
    globalMU.blockUI();
    try {
      await definirFilialTransferenciaItem({
        identificadorItem,
        codigoFilialTransferencia,
      });

      globalMU.unblockUI();
    } catch (e) {
      tratamentoErroPadrao(e);

      globalMU.unblockUI();
    }
  };

  const onVendaSobEncomendaAlterada = async (
    vendaSobEncomenda: boolean,
    identificadorItem: number,


  ) => {

    globalMU.blockUI()

    try {

      await definirVendaSobEncomendaItem({
        identificadorItem,
        vendaSobEncomenda,
      });

      if (globalMU.isNotNullOrEmpty(valorParametro("TRATAR_VENDAS_SOB_ENCOMENDA")) && valorParametro("TRATAR_VENDAS_SOB_ENCOMENDA") != "4") {
        if (vendaSobEncomenda) {
          setMostrarModalVendaSobEncomenda(true)
          setMostrarModalVendaSobEncomendaManual(true)
        }
      }

      globalMU.unblockUI();
    } catch (e) {
      tratamentoErroPadrao(e);
      globalMU.unblockUI();
    }
  };

  const onRemoverServicoAgregado = async (identificadorItem: number) => {
    try {

      globalMU.blockUI();
      var result = await RemoverServicosAgregados(
        orcamento.IdentificadorOrcamento,
        identificadorItem
      );

    } catch (e) {
      tratamentoErroPadrao(e);
    }
    finally {
      globalMU.unblockUI()
    }
  }

  const onServicosAgregadosAlterado = async () => {
    try {
      globalMU.blockUI()

      if (item.ServicoAgregado) {
        onRemoverServicoAgregado(item.Identificador)
        setMostrarModalServicoAgregados(false);
      } else {
        setMostrarModalServicoAgregados(true);
      }

      globalMU.unblockUI();
    } catch (e) {
      tratamentoErroPadrao(e);
      globalMU.unblockUI();
    }
  };

  const onPrioridadeDeMontagemAlterada = async (
    identificadorItem: number,
    prioridadeDeMontagem: boolean
  ) => {
    globalMU.blockUI();
    try {
      await definirPrioridadeMontagemItem({ // 456839
        identificadorItem,
        prioridadeMontagem: prioridadeDeMontagem,
      });
      globalMU.unblockUI();
    } catch (e) {
      tratamentoErroPadrao(e);
      globalMU.unblockUI();
    }
  }

  const onMostruarioAlterado = async (
      identificadorItem: number,
      mostruario: boolean
  ) => {
      globalMU.blockUI();
      try {
          const item = orcamento.ItensOrcamento.find(i => i.Identificador == identificadorItem)
          await alterarMostruarioItem({ item, check: mostruario }); // PA 487087
          globalMU.unblockUI();
      } catch (e) {
          tratamentoErroPadrao(e);
          globalMU.unblockUI();
      }
  }

  const onEncomendaExpressaAlterada = async (encomendaExpressa: boolean, identificadorItem: number) => {  // 433263
    globalMU.blockUI()
    try {
      await definirEncomendaExpressaItem({ identificadorItem, encomendaExpressa, }) // 433263
    } catch (e) { tratamentoErroPadrao(e) }
    finally { globalMU.unblockUI() }
  };

  const onAliquotaAlterada = async (
    aliquota: number,
    identificadorItem: number
  ) => {
    globalMU.blockUI();
    try {
      await definirAliquotaItem({
        identificadorItem,
        aliquota,
      });

      globalMU.unblockUI();
    } catch (e) {
      tratamentoErroPadrao(e);

      globalMU.unblockUI();
    }
  };

  const onPedidoCompraAlterada = async (
    identificadorItem: number,
    pedidoDeCompra: string
  ) => {
    globalMU.blockUI();
    try {
      await definirPedidoDeCompraItem({
        identificadorItem,
        pedidoDeCompra,
      });
      globalMU.unblockUI();
    } catch (e) {
      tratamentoErroPadrao(e);

      globalMU.unblockUI();
    }
  };

  const onLinhaOrdemPedidoAlterada = async (
    identificadorItem: number,
    linhaOrdemCompra: string
  ) => {
    globalMU.blockUI();
    try {
      await alterarOrdemPedidoCompraItem({
        identificadorItem,
        linhaOrdemPedidoCompra: linhaOrdemCompra,
      });
      globalMU.unblockUI();
    } catch (e) {
      tratamentoErroPadrao(e);

      globalMU.unblockUI();
    }
  };

  const onRegimeEspecialAlterada = async (
    identificadorItem: number,
    desativaRegimeEspecial: boolean
  ) => {
    globalMU.blockUI();
    try {
      await definirRegimeEspecialItem({
        identificadorItem,
        desativaRegimeEspecial: desativaRegimeEspecial,
      });
      globalMU.unblockUI();
    } catch (e) {
      tratamentoErroPadrao(e);

      globalMU.unblockUI();
    }
  };

  const onDespesasIncludasAlterada = async (identificadorItem: number, ativado: boolean) => {
    globalMU.blockUI()

    try {
      await definirDespesasInclusasParaItemOrcamento({
        identificadorItem,
        ativado
      })
      globalMU.unblockUI();
    } catch (e) {
      tratamentoErroPadrao(e)

      globalMU.unblockUI()
    }
  };

  const atualizarDesativarEdicaoOrdemPedidoCompra = async () => {
    try {
      setDesativarEdicaoOrdemPedidoCompra(
        !(await microuniversoApi.Orcamento.possuiPermissaoInformarLinhaPedidoCompra(
          orcamento.IdentificadorOrcamento
        ))
      );
    } catch (e) {
      tratamentoErroPadrao(e);
    }
  };

  const atualizarModalidadesDeEntregaEPontosDeRetirada = async () => {
    try {
      const resposta = await microuniversoApi.Orcamento.listaModalidadeEntrega(orcamento.IdentificadorOrcamento);
      setListaModalidadesEntrega(resposta?.ModalidadesEntrega);
      setListaPontosRetirada(resposta?.PontosRetirada);
      setUtilizaModalidadeEntregaOrcamento(resposta?.UtilizaModalidadeEntregaOrcamento);
    } catch (e) {
      tratamentoErroPadrao(e);
    }
  };

  const onTipoEntregaAlterada = async (
    identificadorItem: number,
    codigoTipoEntrega: CodigoTipoEntrega
  ) => {
    globalMU.blockUI();
    try {
      await alterarTipoEntregaItem({
        identificadorItem: identificadorItem,
        codigoTipoEntrega: codigoTipoEntrega,
        itemOrcamento: orcamento.ItensOrcamento.find((item) => item.Identificador == identificadorItem)
      });
      globalMU.unblockUI();
    } catch (e) {
      tratamentoErroPadrao(e);

      globalMU.unblockUI();
    }
  };

  const onOfertaSeletivaAlterada = async (
    identificadorItem: number,
    ofertaSelecionada: boolean
  ) => {
    globalMU.blockUI();
    try {
      await definirOfertaSeletivaItem({
        identificadorItem,
        ofertaSelecionada: ofertaSelecionada,
      });
      globalMU.unblockUI();
    } catch (e) {
      tratamentoErroPadrao(e);

      globalMU.unblockUI();
    }
  };

  const onValorIPIAlterada = async (
    identificadorItem: number,
    valor: number
  ) => {
    globalMU.blockUI();
    try {
      await definirValorIPIItem({
        identificadorItem,
        valor: valor,
      });
      globalMU.unblockUI();
    } catch (e) {
      tratamentoErroPadrao(e);

      globalMU.unblockUI();
    }
  };

  const onEntregaPosteriorAlterada = async (
    identificadorItem: number,
    entregaPosterior: boolean
  ) => {
    globalMU.blockUI();
    try {
      await definirEntregaPosteriorItem({
        identificadorItem,
        entregaPosterior: entregaPosterior,
      });
      globalMU.unblockUI();
    } catch (e) {
      tratamentoErroPadrao(e);

      globalMU.unblockUI();
    }
  }

  const motivoDescontoAlterado = async (identificadorItem: number, codigoMotivoDesconto: number) => {
    await DefinirMotivoDescontoItem({
      identificadorItem,
      codigoMotivoDesconto
    })
  }

  const atualizarMotivosDesconto = async () => {
    setMotivosDesconto(
      await microuniversoApi.Orcamento.obterMotivosDesconto()
    )
  }

  useEffect(() => {
    if (parametrosPorFilial?.length > 0 && parametros.length > 0) {

        setParametrosCarregados(true)
      }
    }
, [parametrosPorFilial, parametros])

  useEffect(() => {
    
    if (parametrosCarregados == true && parametrosPorFilial?.length > 0) {
      
      listarFiliaisRetirada()
      atualizarExibicaoLocalRetirada()
      listarTurnoEntrega() // 475897
      }

  }, [parametrosCarregados])


  useEffect(() => {
    atualizarParametros()
    listarTipoEntrega()
    //listarFiliaisRetirada()
    listarTiposFaturamento()
    //// 475897 listarTurnoEntrega()
    //atualizarExibicaoLocalRetirada()
    atualizarDesativarEdicaoOrdemPedidoCompra()
    atualizarModalidadesDeEntregaEPontosDeRetirada()
    atualizarMotivosDesconto()
  }, [props.identificadorItem])

  useEffect(() => {
    setItem((orcamento.ItensOrcamento ?? []).find(i => i.Identificador == props.identificadorItem))

    if (orcamento.NumeroDiasMaximoParaPrevisaoEntrega && orcamento.NumeroDiasMaximoParaPrevisaoEntrega > 0) {
      const dataMaxima = new Date()
      dataMaxima.setDate(dataMaxima.getDate() + orcamento.NumeroDiasMaximoParaPrevisaoEntrega)
      setDataMaximaParaPrevisaoEntrega({ year: dataMaxima.getFullYear(), month: dataMaxima.getMonth() + 1, day: dataMaxima.getDate() })
    }

  }, [orcamento.ItensOrcamento, props.identificadorItem])


  const botaoAnterior = (
    <button
      className={clsx(
        estilosBotoes.botaoIcone,
        estilosBotoes.botaoIconeAzul,
        "no-global-button"
      )}
      disabled={props.botaoAnteriorDesativado}
      accessKey="<"
      title="Tecla de atalho [<]"
      onClick={() => props.onBotaoAnteriorClicado()}
    >
      <FontAwesomeIcon icon={faCircleLeft} />
      Anterior
    </button>
  );

  const botaoProximo = (
    <button
      className={clsx(
        estilosBotoes.botaoIcone,
        estilosBotoes.botaoIconeAzul,
        "no-global-button"
      )}
      accessKey=">"
      title="Tecla de atalho [>]"
      onClick={() => props.onBotaoProximoClicado()}
    >
      <FontAwesomeIcon icon={faCircleRight} />
      Próximo
    </button>
  );

  const regionsComponentesLegados = `
      <div id="venda-produto-estoque-indisponivel-region" style="display: none;" region></div>
  `

  return (
    <>
      <div dangerouslySetInnerHTML={{ __html: regionsComponentesLegados }}></div>

      <>

        <Breadcrumb2Container
          exibirBotaoLimpar={false}
          exibirBotaoVoltar={true}
          id="breadcrumb-orcamento"
          onBotaoVoltarClicado={() => {

            renderizarComponentReact(<ItensOrcamentoContainer />, "conteudo-pagina", true)

          }}
          passos={["Itens", "Editar itens"]}
          onPassoSelecionado={passo => {
            if (passo == "Itens") {
              window.orcamentoController.showView({
                region: {
                  name: "itemOrcamentoRegion",
                  selector: "#itens-orcamento-region"
                },
                controller: {
                  type: ItemOrcamentoController,
                  args: {
                    model: window.orcamentoController.model,
                    orcamentoController: window.orcamentoController,
                    readOnly: orcamento.SomenteLeitura || orcamento.CodigoDAV !== "" // this.model.get("SomenteLeitura") || this.model.get("CodigoDAV") !== "" // fnx-968
                  }
                }
              })
            }
          }}
        />

        {props.exibirBotoesProximoEAnterior && (
          <div className="_flex _flex-row _gap-4">
            {botaoAnterior}

            {botaoProximo}
          </div>
        )}

        {parametrosCarregados && <EditarItem
          item={orcamento.ItensOrcamento.find(i => i.Identificador == props.identificadorItem)}
          tiposEntrega={tipoEntrega}
          listaTurnoEntrega={turnoEntrega}
          filiaisRetirada={filiaisRetirada} // 472865
          filiaisTransferencia={filiais}
          listaTiposFaturamento={faturamento}
          permitirEditarDescricao={valorParametroPorFilial("PERMITE_INCLUIR_DESCRICAO_TEMP_PRODUTO_ORCAMENTO") == "S"}
          bloquearFaturamentoDiretoClienteRetiradaOutroLocal={valorParametroPorFilial("BLOQUEAR_FATURAMENTO_DIRETO_CLIENTE_RETIRADA_OUTRO_LOCAL") == "S"} // 469010
          exibirClasseEFornecedor={!item.ProdutoForaEstoque}
          descricaoTipoOrcamento={item.DescricaoTipoOrcamento}
          tipoOrcamento={item.TipoOrcamento}
          mostrarLocalRetirada={exibirLocalRetirada}
          dataMaximaParaPrevisaoEntrega={dataMaximaParaPrevisaoEntrega}
          desativarEdicaoOrdemPedidoCompra={
            desativarEdicaoOrdemPedidoCompra
          }
          desabilitarTipoEntrega={orcamento.TipoEntregaPadrao !==""} // 474918
          utilizaModalidadeEntregaOrcamento={utilizaModalidadeEntregaOrcamento}
          listaModalidadesEntrega={listaModalidadesEntrega}
          listaPontosRetirada={listaPontosRetirada}
          definirPrevisaoEntregaPorItem={
            valorParametro("DEFINIR_PREVISAO_ENTREGA_POR_ITEM") == "S"
          }
          valorTratarVendasSobEncomenda={valorParametro("TRATAR_VENDAS_SOB_ENCOMENDA") as "0" | "1" | "2" | "3" | "4"}
          vendaComEntregaPosteriorPorItem={
            valorParametroPorFilial("VENDA_COM_ENTREGA_POSTERIOR_POR_ITEM") == "S"
          }
          apuraStOrcamento={valorParametro("APURAR_ST_ORCAMENTO") == "S"}
          apuraIpiVenda={
            valorParametro("APURA_IPI_VENDA") == "S" ||
            valorParametroPorFilial("APURA_IPI_VENDA_FILIAL") == "S"
          }
          bloquearDescontoUnitarioOrcamento={valorParametro("BLOQUEIA_DESCONTO_UNITARIO_NO_ORCAMENTO") === "S"}
          bloquearEdicaoValorIpiOrcamento={
            valorParametro("BLOQUEAR_EDICAO_VALOR_IPI_ORCAMENTO") == "S"
          }
          permiteDesativarRegimeEspecialItemPedido={
            valorParametroPorFilial(
              "PERMITE_DESATIVAR_REGIME_ESPECIAL_ITEM_PEDIDO"
            ) == "S"
          }
          utilizaEmissaoAutomaticaNFVendaAposTransferencia={
            valorParametroPorFilial(
              "UTILIZA_EMISSAO_AUTOMATICA_NF_VENDA_APOS_TRANSFERENCIA_CD"
            ) == "S"
          }
          tratamentoDiferenciadoDatasMarcadasEPrevistas={
            valorParametro(
              "TRATAMENTO_DIFERENCIADO_DATAS_MARCADAS_PREVISTAS_ORCAMENTO"
            ) == "S"
          }
          exibirCampoMarkup={valorParametro("CUSTO_PARA_GERAR_MARKUP") != "" && valorParametro("VISUALIZA_MARKUP_PRODUTO_ORCAMENTO") == "S"} // 449240
          valorDespesasInclusas={
            orcamento.ValorDespesasInclusas &&
            orcamento.ValorDespesasInclusas > 0
          }
          desativarEdicaoRegimeEspecial={item.BloquearRegimeEspecial || item.TipoFaturamento != 0} //TipoFaturamento=1 -> DiretoCliente ; 0->Transferencia
          utilizaRecursoEncomendaExpressa={valorParametroPorFilial("UTILIZA_RECURSO_ENCOMENDA_EXPRESSA") == "S"} // 433263
          desativarSelecaoPontoRetirada={item.OidModalidadeEntrega != 39669}
          somenteLeitura={orcamento.SomenteLeitura}
          vendaPorRepresentacao={orcamento.OidFornecedorPorRepresentacao > 7} // 456252
          onDescricaoModificado={onDescricaoAlterado}
          onQuantidadeModificado={onQuantidadeAlterado}
          onPercentualMarkUpModificado={onPercentualMarkUpModificado} // 449240
          onPrecoModificado={onPrecoItemAlterado}
          onTipodeEntregaModificado={codigoTipoEntrega => onTipoEntregaAlterada(item.Identificador, codigoTipoEntrega)}
          onDataPrevistaModificado={data => onDataPrevistaAlterado(data, item.Identificador)}
          onDataMarcadaModificado={data => onDataMarcadaAlterado(data, item.Identificador)}
          onTurnoModificado={turnoEntrega => onTurnoEntregaAlterado(item.Identificador, turnoEntrega)}
          onFilialdeRetiradaModificado={codigoFilialRetirada => onFilialRetiradaAlterada(codigoFilialRetirada, item.Identificador)}
          onFilialDeTransferenciaModificado={codigoFilialTransferencia => onFilialTransferenciaAlterada(codigoFilialTransferencia, item.Identificador)}
          onIdPontoRetiradaModificado={idPontoRetirada => onIdPontoRetiradaAlterado(idPontoRetirada, item.Identificador)}
          onOidModalidadeEntregaModificado={oidModalidadeEntrega => onOidModalidadeEntregaAlterado(oidModalidadeEntrega, item.Identificador)}
          onFaturamentoModificado={tipoFaturamento => onTipoFaturamentoAlterado(tipoFaturamento, item.Identificador)}
          onPedidoDeCompraModificado={onPedidoCompraAlterada}
          onLinhaDeCompraModificado={onLinhaOrdemPedidoAlterada}
          onAliquotaModificado={onAliquotaAlterada}
          onValorIPIModificado={onValorIPIAlterada}
          onClickSimularDesconto={async () => setItemSelecionadoParaSimularDesconto(item)}

          onReplicarDataMarcadaEmTodosOsItens={() => onReplicarData(item.DataMarcadaEntrega)}
          onEntregaPosteriorModificado={onEntregaPosteriorAlterada}
          onVendaSobEncomendaModificado={onVendaSobEncomendaAlterada}
          onServicosAgregadosModificado={onServicosAgregadosAlterado}
          onEncomendaExpressaModificada={onEncomendaExpressaAlterada}  // 433263
          onPrioridadeDeMontagemModificado={onPrioridadeDeMontagemAlterada}  // 456839
          onMostruarioModificado={onMostruarioAlterado} // PA 487087
          onOfertasSeletivasModificado={onOfertaSeletivaAlterada}
          onDespesasInclusasModificado={ativado => onDespesasIncludasAlterada(item.Identificador, ativado)}
          onRegimeEspecialModificado={onRegimeEspecialAlterada}

          onProdutoSemEstoqueDisponivel={(item) => {
            if (orcamento.TipoOrcamento == 2) {
              return
            }

            props.onExibirTelaProdutoSemEstoqueDisponivel()

          }}
          ofertaSeletivaAtivada={orcamento.TipoOrcamentoDescricao == "Venda" && item.OidOferta > 0}
          ofertaSeletivaVisivel={orcamento.TipoOrcamentoDescricao == "Venda" && !item.ProdutoForaEstoque && valorParametro("OFERTA_SELETIVA") == "S"}
          despesasInclusasVisivel={orcamento.TipoOrcamento !== 2 && valorParametroPorFilial("EXIBIR_OUTRAS_DESPESAS_ITENS_ORCAMENTO") == "S"}
          despesasInclusasAtivada={orcamento.ValorDespesasInclusas > 0}
          exibirAlertaEstoqueIndisponivel={item.BloqueadoEstoque && valorParametro("ACEITAR_PRODUTO_SEM_ESTOQUE") != "S"}
          exibirBotaoSimularDesconto={
            globalMU.isNullOrEmptyOrZero(item.CodigoTinta) &&
            !item.ProdutoForaEstoque &&
            orcamento.TipoOrcamento !== 2 &&
            // 431591-- !(!item.PermiteAlterarPreco && valorParametro("BLOQUEIA_DESCONTO_UNITARIO_NO_ORCAMENTO") == "S") &&
            !(orcamento.PercentualDescontoPadraoCliente > 0 && valorParametro("DESCONTO_ACUMULADO") != "S")}
          exibirInputPreco={globalMU.isNullOrEmptyOrZero(item.CodigoTinta)}
          numeroCasasDecimaisPreco={numeroCasasDecimaisPreco()}
          exibirCheckBoxPreservarDesconto={valorParametro("DESCONTO_ACUMULADO") == "S" && valorParametro("PERMITIR_PRESERVAR_DESCONTO_ITEM_ORCAMENTO") == "S"}
          exibirTipoEntrega={orcamento.TipoOrcamento !== 2}
          onAlterarPrecoTinta={() => {
            renderizarComponentReact(
              <EditarPrecoTintaContainer
                item={item}
                itemOrcamentoController={props.itemOrcamentoController} />, "conteudo-pagina", true)
          }}
          motivosDesconto={motivosDesconto}
          onMotivoDescontoAlterado={codigoMotivoDesconto => motivoDescontoAlterado(item.Identificador, codigoMotivoDesconto)}
          utilizaServicoAgregadoNoOrcamento={valorParametroPorFilial("UTILIZA_SERVICO_AGREGADO_ORCAMENTO") == "S" && orcamento.TipoOrcamentoDescricao == "Venda"}
        />}




        {itemSelecionadoParaSimularDesconto != null && <ModalSimularDescontoContainer
          item={itemSelecionadoParaSimularDesconto}
          onAplicado={() => setItemSelecionadoParaSimularDesconto(null)}
          onCancelar={() => setItemSelecionadoParaSimularDesconto(null)}

        />}

        {mostrarModalVendaSobEncomenda && <ModalVendaSobEncomendaContainer
          onFecharCaixaDeDialogo={() => (setMostrarModalVendaSobEncomenda(false), setMostrarModalVendaSobEncomendaManual(false))}
          onCancelarCaixaDeDialogo={() => (setMostrarModalVendaSobEncomenda(false), setMostrarModalVendaSobEncomendaManual(false), onVendaSobEncomendaAlterada(false, props.identificadorItem))}
          identificadorItem={props.identificadorItem}
          solicitacaoAberturaModalManual={mostrarModalVendaSobEncomendaManual} />}


        {mostrarModalServicoAgregados &&
          <ModalServicosAgregadosContainer
            item={item}
            onFechar={() => setMostrarModalServicoAgregados(false)}

          />
        }
      </>
    </>
  );
};

